<loader *ngIf="showLoader"></loader>
<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">

                <div>
                    <div class="col-md-12 mb-20 text-start" style="color: black;font-weight: 600;">
                        <p>You're just one step away from getting your eSIM!</p>  
                    </div>
                
                    <form #form="ngForm" (ngSubmit)="onSubmit(form)">

                        <div class="row" style="margin-bottom: 20px;" *ngIf="this.orderType == 'BUY'">
                            <div class="col-12 col-md-6">
                                <div class="form-check form-check-inline sim-type-container">
                                    <input class="form-check-input fs-13" type="radio" name="esim_steps" [(ngModel)]="simType" id="esim" value="E-SIM" required>
                                    <label class="form-check-label fs-13" for="esim">eSIM</label>
                                </div>
                                <div class="form-check form-check-inline sim-type-container">
                                    <input class="form-check-input fs-13" type="radio" name="esim_steps" [(ngModel)]="simType" id="psim" value="PHYSICAL" required>
                                    <label class="form-check-label fs-13" for="psim">P-Sim</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <span *ngIf="form.submitted && !form.controls['esim_steps']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>                                
                            </div>
                            <div class="col-12">
                                <div class="d-flex justify-content-start align-items-center phone-check-list" *ngIf="simType == 'E-SIM'">
                                    <img src="assets/images/buy-esim/vector.png">
                                    <p class="fs-11 mb-0 fw-500 ml-10"> Check if your phone is <span style="text-decoration: underline;color: #1D2A62; cursor: pointer;" (click)="opendevicesModal()">eSIM compatible</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                                       
                                    


                        <div class="row m-0">
                            
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">First Name*</label>
                                <input type="text" name="firstName" class="form-control fs-12" placeholder="First Name*" [(ngModel)]="firstName" required (keypress)="letterOnly($event)">
                                <span *ngIf="form.submitted && !form.controls['firstName']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                    
                          
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">Last Name*</label>
                                <input type="text" name="lastName" class="form-control fs-12" placeholder="Last Name*" [(ngModel)]="lastName" required (keypress)="letterOnly($event)">
                                <span *ngIf="form.submitted && !form.controls['lastName']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                           
                    
                      
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">Email ID*</label>
                                <input type="email" name="email" class="form-control fs-12" placeholder="Enter Email ID*" [(ngModel)]="email" required>
                                <span *ngIf="form.submitted && !form.controls['email']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                    
                          
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">Mobile No*</label>
                                <input type="text" name="mobile_no" class="form-control fs-12" placeholder="Enter Mobile No*" [(ngModel)]="mobileNo" required maxlength="10" pattern="^[1-9][0-9]*$" oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';">
                                <span *ngIf="form.submitted && !form.controls['mobile_no']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                        </div>
                    
                        <div class="row m-0">
                    
                        
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">Pan Card*</label>
                                <input type="text" name="pancard" class="form-control fs-12" placeholder="Pan card" [(ngModel)]="panCard" required>
                                <span *ngIf="form.submitted && !form.controls['pancard']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                       
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">Address*</label>
                                <input type="text" name="address" class="form-control fs-12" placeholder="Enter Address*" [(ngModel)]="address" required [pattern]="addressPattern"
                                oninput="this.value = this.value.replace(/[^a-zA-Z0-9,\s]/g, '');">
                                <span *ngIf="form.submitted && !form.controls['address']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                    
                        
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">State*</label>
                                <input type="text" name="state" class="form-control fs-12" placeholder="State" [(ngModel)]="state" required>
                                <span *ngIf="form.submitted && !form.controls['state']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                    
                         
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 form-group">
                                <label class="form-label text-black fs-11">City*</label>
                                <input type="text" name="city" class="form-control fs-12" placeholder="City" [(ngModel)]="city" required>
                                <span *ngIf="form.submitted && !form.controls['city']?.valid" class="invalid-form">
                                    <small class="form-text text-danger">This field is required!</small>
                                </span>
                            </div>
                        </div>
                    
                        <div class="col-md-12 mb-20 text-start fs-10 mt-2" style="color: black; font-weight: 500;">
                            <label style="font-weight: 400;">
                                <input type="checkbox" name="terms" [(ngModel)]="isChecked" required />
                                I agree to the Terms & Conditions, acknowledging that this product is offered by WSFx in collaboration with Zetexa and is subject to the companies' policies.
                            </label>
                            <span *ngIf="form.submitted && !isChecked" class="invalid-form">
                                <small class="form-text text-danger">You must agree to the Terms and Conditions to proceed.</small>
                            </span>
                        </div>
                        
                        <div class="row mt-20">
                            <div class="col-md-12 col-9 text-right">
                             
                                <button type="submit" rippleEffect class="btn btn-primary fs-12"> Submit </button>
                            </div>
                        </div>
                       
                    </form>
                </div>


            </div>
        </div>
    </div>
</div>                    
<ng-template #eSimSuccessModal let-modal>
    <div class="success-img ">
      <img src="assets/images/esim/success.png" class="success-img" style="margin-top: 30px;margin-left: 200px;" >
    </div>
    <div class="text-center fw-600">YAY!</div>
    <div class="text-center fw-600 "> Your eSIM order has been successfully placed. Look out for activation details on your email from orders@zetexa.com</div>
    
    <div class="col-md-12 mt-20 mb-20 d-flex justify-content-center">
        <button type="button" rippleEffect class="btn btn-primary fs-10 w-80" (click)="closeModalAndNavigate()">
          Ok
        </button>
      </div>
      
  </ng-template>
  <ng-template #devicesModal let-modal>
    <div class="d-flex flex-column w-100 h-100">
        <div class="flex-grow-1 d-flex flex-column">
            <ul ngbNav #nav="ngbNav" class="nav nav-pills nav-justified w-100 custom-nav-tabs">
                <li class="nav-item w-50" ngbNavItem>
                    <a ngbNavLink class="nav-link fs-12 text-center" 
                        [ngClass]="{ 'active': activeTab === 'iosDevices' }" 
                        (click)="setActiveTab('iosDevices')">
                        IOS Devices
                    </a>
                    <ng-template ngbNavContent>
                        <section id="iosDevices" class="d-flex flex-column flex-grow-1 w-100">
                            <div class="flex-grow-1 d-flex flex-column align-items-start w-100 p-2">
                                <div class="w-100" *ngIf="iosItems.length > 0">
                                    <div class="d-flex align-items-center justify-content-start single-devices w-100 p-10"
                                         *ngFor="let device of iosItems">
                                        <div class="fs-11 fw-600 w-100 text-truncate">
                                            {{ device }}
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="iosItems.length === 0" class="text-center w-100">
                                    <p>No iOS devices available.</p>
                                </div>
                            </div>
                        </section>
                    </ng-template>
                </li>

              
                <li class="nav-item w-50" ngbNavItem>
                    <a ngbNavLink class="fs-12 text-center" 
                        [ngClass]="{ 'active': activeTab === 'androidDevices' }" 
                        (click)="setActiveTab('androidDevices')">
                        Android Devices
                    </a>
                    <ng-template ngbNavContent>
                        <section id="androidDevices" class="d-flex flex-column flex-grow-1 w-100">
                            <div class="flex-grow-1 d-flex flex-column align-items-start w-100 p-2">
                                <div class="w-100" *ngIf="androidItems.length > 0">
                                    <div class="d-flex align-items-center justify-content-start single-devices w-100 p-10"
                                         *ngFor="let device of androidItems">
                                        <div class="fs-11 fw-600 w-100 text-truncate">
                                            {{ device }}
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="androidItems.length === 0" class="text-center w-100">
                                    <p>No Android devices available.</p>
                                </div>
                            </div>
                        </section>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="flex-grow-1 w-100"></div>
        </div>
    </div>
</ng-template>